var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-contextual-images"},[_c('ConditionInput',{attrs:{"value":_vm.value},on:{"click":() => {
        _vm.show = true
        _vm.$emit('track', 'ContextualImages')
      }}}),(_vm.show)?_c('Modal',{attrs:{"value":_vm.value},on:{"input":$ev => _vm.$emit('input', $ev),"close":function($event){_vm.show = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }